// SmsSettings only. Shared table methods are in tableMixin.js.
export default {
    name: "SmsSettings",
    methods: {
        clearForm() {
            this.isEditing = false;
            this.isSaving = false;
            this.submitted = false;
            this.formInputs.id = "";
            this.formInputs.api_username = "";
            this.formInputs.api_key = "";
            this.formInputs.api_userid = "";
            this.$clearValidationStates("#recordForm");
        },
    },
};